export default function Marquee({ items, testid }) {
    const row = (hidden) => (
        <ul
            aria-hidden={hidden || undefined}
            className="flex shrink-0 items-center"
        >
            {items.map((it, i) => (
                <li
                    key={i}
                    className="flex items-center gap-8 pr-8 sm:gap-12 sm:pr-12"
                >
                    <span className="whitespace-nowrap font-display text-lg font-semibold text-ink/90 sm:text-2xl">
                        {it}
                    </span>
                    <svg
                        viewBox="0 0 24 24"
                        className="h-3.5 w-3.5 fill-ink/30"
                        aria-hidden="true"
                    >
                        <polygon points="12,1.5 21.5,7 21.5,17 12,22.5 2.5,17 2.5,7" />
                    </svg>
                </li>
            ))}
        </ul>
    );
    return (
        <div
            data-testid={testid}
            className="marquee relative z-10 rotate-[-1deg] overflow-hidden border-y-2 border-ink/10 bg-honey py-4 shadow-[0_10px_30px_rgba(245,158,11,0.25)] sm:py-5"
        >
            <div className="marquee-track flex w-max">
                {row(false)}
                {row(true)}
            </div>
        </div>
    );
}
